import { FontSizes, FontWeights, getTheme, IStyle, mergeStyleSets } from '@fluentui/react'

export const useBillboardStyles = () => {
  const theme = getTheme();

  const billboard: IStyle = {
    margin: 0,
    padding: 0,
    flexGrow: 1,
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.neutralLighterAlt,
    color: theme.palette.neutralSecondary,
    height: '100%',
  };
  const iconContainer: IStyle = {
    margin: '0 20px',
    padding: 0,
  };
  const icon: IStyle = {
    fontSize: 100,
  };
  const message: IStyle = { 
    fontWeight: FontWeights.regular,
    marginTop: FontSizes.xxLarge,
    paddingLeft: FontSizes.xxLarge,
    paddingRight: FontSizes.xxLarge,
  };
  const button: IStyle = {
    marginRight: 20,
  };
  const buttonContainer: IStyle = {
    marginTop: FontSizes.xxLarge,
    paddingLeft: FontSizes.xxLarge,
    paddingRight: FontSizes.xxLarge,
    '& button': button,
    '& button:last-child': { margin: 0 }
  };

  return mergeStyleSets({
    billboard,
    iconContainer,
    message,
    buttonContainer,
    icon,
  });
}